const trackingEnabled = import.meta.env.VITE_SENTRY_ENABLED === 'true';
const sampleRate = trackingEnabled ? 0.01 : 0.0;

// NOTE: `integrations` is injected by the caller (rather than this module importing
// @sentry/react itself) because web and mobile can be on different major versions of
// the Sentry SDK (mobile's @sentry/capacitor requires a newer @sentry/react than web's
// @sentry/react). Building the integration here would always resolve to whichever
// @sentry/react is hoisted for this shared package, not the version the calling app
// actually uses.
export const sentryConfig = (integrations) => ({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_BUILD_ENVIRONMENT,
  release: import.meta.env.VITE_RELEASE,
  integrations,
  // Warning: Don't set too deep or errors won't
  // get send as they are getting to big!
  normalizeDepth: 3,
  tracesSampleRate: sampleRate,
  ignoreErrors: ['ResizeObserver loop'],
  beforeSend: (event) => {
    if (trackingEnabled) {
      return event;
    }
    return null;
  },
  debug: false,
  // Must be an array: a plain string is iterated per character, which matches every URL
  // and adds sentry-trace/baggage headers to third-party requests (e.g. Mux uploads -> CORS failure).
  tracePropagationTargets: [import.meta.env.VITE_API_BASE_URL].filter(Boolean),
});
